export const convertNullToUndefined = (array: any[]) => {
  return array.map((value) => (value === null || value === undefined ? undefined : value));
};
